import React, { useState } from "react";

import { Grid, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import ruLocale from "date-fns/locale/ru";
import GenderSelect from "../../../components/Autocompletes/GenderSelect";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

export const ReferralPatientCreateModal = ({ open, setOpen, onSubmit }) => {
  const [patient, setPatient] = useState({});

  const handleChangeNewPatient = (key, value) => {
    const data = {
      ...patient,
      [key]: value,
    };


    // setPatient({...patient, ...data});
  };

  const handleSubmit = (e, data) => {
  };

  return (
    true && (
      <Grid container spacing={1} sx={{ paddingLeft: "8px" }}>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required
            value={patient?.identityNumber}
            onChange={(e) =>
              handleChangeNewPatient("identityNumber", e.target.value)
            }
            fullWidth
            id="targetPatient_identityNumber"
            name="targetPatient_identityNumber"
            label="ИИН"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required
            value={patient?.lastName}
            onChange={(e) => handleChangeNewPatient("lastName", e.target.value)}
            fullWidth
            id="targetPatient_lastName"
            name="targetPatient_lastName"
            label="Фамилия"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required
            value={patient?.firstName}
            onChange={(e) =>
              handleChangeNewPatient("firstName", e.target.value)
            }
            fullWidth
            id="targetPatient_firstName"
            name="targetPatient_firstName"
            label="Имя"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required
            value={patient?.secondName}
            onChange={(e) =>
              handleChangeNewPatient("secondName", e.target.value)
            }
            fullWidth
            id="targetPatient_secondName"
            name="targetPatient_secondName"
            label="Отчество"
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask
            mask="+7 999 999 99 99"
            value={patient?.phoneNumber}
            onChange={(e) =>
              handleChangeNewPatient("phoneNumber", e.target.value)
            }
          >
            {() => (
              <TextField
                id="targetPatient_phoneNumber"
                label="Телефон"
                name="targetPatient_phoneNumber"
                fullWidth
                margin="normal"
                type="text"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required
            value={patient?.rpnId}
            onChange={(e) => handleChangeNewPatient("rpnId", e.target.value)}
            fullWidth
            id="targetPatient_rpnId"
            name="targetPatient_rpnId"
            label="Идентификатор РПН"
          />
        </Grid>
        <Grid item xs={6}>
          <LocalizationProvider locale={ruLocale} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["day", "year"]}
              label="Дата рождения"
              value={patient?.birthDate}
              onChange={(newValue) =>
                handleChangeNewPatient("birthDate", newValue)
              }
              
              renderInput={(params) => (
                <TextField
                  fullWidth
                  margin="normal"
                  {...params}
                  helperText={null}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6}>
          <GenderSelect
            required
            value={patient?.genderId}
            onChange={(val) => handleChangeNewPatient("genderId", val)}
            margin="normal"
            fullWidth
            label="Пол"
            id="targetPatient_genderId"
            select
          />
        </Grid>
      </Grid>
    )
  );
};

ReferralPatientCreateModal.defaultProps = {
  open: true,
  onSubmit: () => {},
};
